import styled from 'styled-components';
import Modal from '../Modal';
import {ModalTwoButtonsWrapper} from '../../styled/common';

export const StyledModal = styled(Modal)``;

export const ModalTwoButtons = styled(ModalTwoButtonsWrapper)`
  margin-top: auto;
`;
